import cuid from 'cuid';

import { CREATE_PROFILE } from './profileConstants';
import { toastr } from 'react-redux-toastr';
import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from '../../../common/async/asyncActionStart';

import 'firebase/firestore';
import { firestore } from 'firebase/app';

const { serverTimestamp } = firestore.FieldValue;

export const createProfile = profile => {
  return {
    type: CREATE_PROFILE,
    payload: {
      profile
    }
  };
};

export const isNewUser = user => async (
  dispatch,
  getState,
  { getFirebase }
) => {
  const firebase = getFirebase();
  const { isLoaded, isEmpty, ...updatedUser } = user;
  console.log('new user');
  updatedUser.isNewUser = false;
  try {
    dispatch(asyncActionStart());
    await firebase
      .updateProfile(updatedUser)
      .then(() => {
        dispatch(asyncActionFinish());
        toastr.success('Success', 'Your profile has been updated');
      })
      .catch(error => {
        toastr.error(
          'Error',
          'Your profile was not updated. Error: ' + error.message
        );
        console.error(error);
      });
  } catch (error) {
    dispatch(asyncActionError());
    toastr.error(
      'Error',
      'Your profile was not updated. Error: ' + error.message
    );
    console.error(error);
  }
};

export const updateProfile = user => async (
  dispatch,
  getState,
  { getFirebase }
) => {
  const firebase = getFirebase();
  const { isLoaded, isEmpty, ...updatedUser } = user;
  //updatedUser.profileIsEmpty = false;
  console.log('user', updatedUser);

  if (updatedUser.userAddress1 && updatedUser.userAddress1.length > 0) {
    updatedUser.profileIsEmpty = false;
    updatedUser.isNewUser = false;
  }
  console.log('user', updatedUser);

  updatedUser.displayName = updatedUser.userFullName || user.displayName;

  try {
    dispatch(asyncActionStart());

    await firebase
      .updateProfile(updatedUser)
      .then(() => {
        dispatch(asyncActionFinish());
        toastr.success('Success', 'Your profile has been updated.');
      })
      .catch(error => {
        toastr.error(
          'Error',
          'Your profile was not updated. Error: ' + error.message
        );
        console.error(error);
      });
  } catch (error) {
    dispatch(asyncActionError());
    toastr.error(
      'Error',
      'Your profile was not updated. Error: ' + error.message
    );
    console.error(error);
  }
};

export const updateLastLogin = user => async (
  dispatch,
  getState,
  { getFirebase }
) => {
  const firebase = getFirebase();
  const { isLoaded, isEmpty, ...updatedUser } = user;
  updatedUser.lastSignIn = serverTimestamp();
  console.log('login', updatedUser);

  try {
    dispatch(asyncActionStart());
    await firebase
      .updateProfile(updatedUser)
      .then(() => {
        dispatch(asyncActionFinish());
        toastr.success('Success', 'Your profile has been updated');
        if (user.isNewUser && user.profileIsEmpty) {
          //   dispatch(
          //     openModal('WelcomeModal', {
          //       history: this.props.history,
          //       closeModal: this.props.closeModal,
          //       updateProfile: this.props.updateProfile,
          //       isNewUser: this.props.isNewUser,
          //       user: this.props.profile
          //     })
          //   );
        }
      })
      .catch(error => {
        toastr.error(
          'Error',
          'Your profile was not updated. Error: ' + error.message
        );
        console.error(error);
      });
  } catch (error) {
    //dispatch(asyncActionError());
    //toastr.error('Error', 'Your profile was not updated. Error: ' + error.message);
    console.error(error);
  }
};

export const updateProfileImage = (file, fileName) => async (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firebase = getFirebase();
  const imageName = cuid();
  const firestore = getFirestore();
  const user = firebase.auth().currentUser;
  const path = `${user.uid}/profile`;
  const options = {
    name: imageName
  };

  try {
    dispatch(asyncActionStart());
    //upload the file to firebase storage
    let uploadedFile = await firebase.uploadFile(path, file, null, options);
    //get url of the image

    let downloadURL = await uploadedFile.uploadTaskSnapshot.ref.getDownloadURL();
    // get user document
    let userDoc = await firestore.get(`users/${user.uid}`);
    // check if user has photo, if not update profile
    if (!userDoc.data().phototURL) {
      await firebase.updateProfile({
        photoURL: downloadURL
      });

      // await user.updateProfile({
      //   phototURL: downloadURL
      // });
    }
    //add the image to firestore
    await firestore.set(
      {
        collection: 'users',
        doc: user.uid + '/photoURL'
      },
      {
        name: imageName,
        url: downloadURL
      }
    );

    dispatch(asyncActionFinish());
    toastr.success('Success', 'Your profile has been updated');
  } catch (error) {
    dispatch(asyncActionError());
    toastr.error(
      'Error',
      'Your profile was not updated with error: ' + error.message
    );

    console.error(error);
  }
};

export const deletePhoto = photo => async (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firebase = getFirebase();
  const firestore = getFirestore();

  const user = firebase.auth().currentUser;

  try {
    await firebase.deleteFile(`${user.uid}/profile/${photo.name}`);
    await firestore.delete({
      collection: 'users',
      doc: user.uid,
      subcollections: [{ collection: 'photos', doc: photo.id }]
    });
  } catch (error) {
    console.error(error);
    throw new Error('Problem deleting photo');
  }
};
